import { ConfirmationModal, Typography } from 'seagull';
import styles from "../SecureLoginModal/SecureLoginModal.module.scss";
import React, { useEffect } from 'react';
import { useOverlayContext } from 'seagull';
import { useHistory, useLocation } from 'react-router-dom';
import { routes } from "../../constants";
import { SecureLoginModal } from "../SecureLoginModal/SecureLoginModal";
export const LoginErrorModal = () => {
  const overlayContext = useOverlayContext();
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    const baseRoute = location.pathname.replace(routes.loginError, '');
    overlayContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ActualLoginErrorModal, {
          dismissModal: dismissModal
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    }).then(shouldOpenSecureLogin => {
      history.replace(baseRoute);
      if (shouldOpenSecureLogin) {
        overlayContext.showModal({
          content: _ref2 => {
            let {
              dismissModal
            } = _ref2;
            return /*#__PURE__*/React.createElement(SecureLoginModal, {
              dismissModal: dismissModal
            });
          },
          closeOnClickOutside: true,
          closeOnEscapeKey: true
        });
      }
    });
    return () => {
      overlayContext.hideModal();
    };
  }, []);
  return null;
};
export const ActualLoginErrorModal = _ref3 => {
  let {
    dismissModal
  } = _ref3;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    "data-testid": "login-error-modal",
    title: "Something went wrong",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.secureLoginModalContainer
    }, /*#__PURE__*/React.createElement(Typography, null, "The email address associated with this account is different from the one you tried to login with."), /*#__PURE__*/React.createElement(Typography, null, "To set up a secure login, you must use the same email address."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, null, "You can always open a Service Provider account using a different email address through www.sayanchor.com")),
    onCloseButtonClick: () => dismissModal(false),
    primaryButtonLabel: "Go back to secure login setup",
    onPrimaryButtonClick: () => dismissModal(true),
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: () => dismissModal(false)
  });
};